import {Component, OnInit, ViewChild} from '@angular/core';
import {FormaDePagamento} from "../../pedidos/objetos/FormaDePagamento";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {NgForm} from "@angular/forms";
import {FormasDePagamentoService} from "../../services/formas-de-pagamento.service";
import {NumerosWhatsappService} from "../../services/numeros-whatsapp.service";
import {NumeroWhatsapp} from "../../pedidos/objetos/NumeroWhatsapp";
import {WhatsappV4Service} from "../../services/whatsapp-v4.service";

@Component({
  selector: 'app-novo-numero-whatsapp',
  templateUrl: './novo-numero-whatsapp.component.html',
  styleUrls: ['./novo-numero-whatsapp.component.scss']
})
export class NovoNumeroWhatsappComponent implements OnInit {
  numeroWhatsapp: NumeroWhatsapp;
  windowRef: DialogRef;
  empresa: any;
  mensagemErro = '';
  telefoneFormatado: string = '';
  @ViewChild('frm',  {static: false} ) frm: NgForm;
  enviando = false;
  carregandoPolitica = false;
  politicaCarregada = false;

  constructor(private dialogService: DialogService, private numerosWhatsappService: NumerosWhatsappService,
              private whatsappV4Service: WhatsappV4Service) {
    this.numeroWhatsapp = new NumeroWhatsapp();
  }

  ngOnInit(): void {
    // Se estiver editando, formatar o telefone existente
    if (this.numeroWhatsapp.whatsapp) {
      this.telefoneFormatado = this.formatarTelefone(this.numeroWhatsapp.whatsapp);
    }
  }

  carreguePolitica() {
    if (this.numeroWhatsapp.whatsapp) {
      this.telefoneFormatado = this.formatarTelefone(this.numeroWhatsapp.whatsapp);
    }

    this.carregandoPolitica = true;
    this.politicaCarregada = false;

    this.whatsappV4Service.obtenhaPolitica(this.empresa, this.numeroWhatsapp).then((resposta: any) => {
      const politica = resposta.politicaEfetiva;
      const resumoHoje = resposta.resumoHoje || {};

      this.numeroWhatsapp.versaoExtensao = Number(resposta.versaoExtensao) || 3;
      this.numeroWhatsapp.limiteDiario = politica.limiteDiario;
      this.numeroWhatsapp.intervaloEnvioSegundos = politica.intervaloEnvioSegundos;
      this.numeroWhatsapp.intervaloMinimoSegundos = politica.intervaloMinimoSegundos;
      this.numeroWhatsapp.limitePorHoraCalculado = politica.limitePorHoraCalculado;
      this.numeroWhatsapp.intervaloCampanhaSegundos = politica.intervaloCampanhaSegundos;
      this.numeroWhatsapp.intervaloAutomacaoSegundos = politica.intervaloAutomacaoSegundos;
      this.numeroWhatsapp.intervaloStatusPedidoSegundos = politica.intervaloStatusPedidoSegundos;
      this.numeroWhatsapp.intervaloAvaliacaoSegundos = politica.intervaloAvaliacaoSegundos;
      this.numeroWhatsapp.intervaloGlobalAutomaticoSegundos = politica.intervaloGlobalAutomaticoSegundos;
      this.numeroWhatsapp.limiteAutomacaoPorHora = politica.limiteAutomacaoPorHora;
      this.numeroWhatsapp.limiteCampanhaPorHora = politica.limiteCampanhaPorHora;
      this.numeroWhatsapp.duracaoMinimaCampanhaHoras = politica.duracaoMinimaCampanhaHoras;
      this.numeroWhatsapp.capacidadeDiariaCalculada = politica.capacidadeDiariaCalculada;
      this.numeroWhatsapp.duracaoDaJanelaHoras = politica.duracaoDaJanelaHoras;
      this.numeroWhatsapp.janelaInicioHora = politica.janelaInicioHora;
      this.numeroWhatsapp.janelaFimHora = politica.janelaFimHora;
      this.numeroWhatsapp.pausado = politica.pausado;
      this.numeroWhatsapp.usadoHoje = resumoHoje.usadoHoje;
      this.numeroWhatsapp.restanteHoje = resumoHoje.restanteHoje;
      this.numeroWhatsapp.proximoEnvioEmMs = resumoHoje.proximoEnvioEmMs;
      this.numeroWhatsapp.incertasHoje = resumoHoje.incertasHoje;
      this.politicaCarregada = true;
      this.carregandoPolitica = false;
    }).catch((erro) => {
      this.mensagemErro = erro;
      this.carregandoPolitica = false;
    });
  }

  async onSalvar() {
    delete this.mensagemErro;

    if(!this.frm.valid || !this.politicaCarregada){
      return;
    }

    this.ajusteLimiteAJanela();

    // Garantir que o telefone está limpo antes de salvar
    this.numeroWhatsapp.whatsapp = this.limparTelefone(this.telefoneFormatado);

    this.enviando = true;

    try {
      const resposta = await this.numerosWhatsappService.salveNumeroWhatsapp(this.numeroWhatsapp, this.empresa);

      this.numeroWhatsapp.id = resposta.id;
      await this.whatsappV4Service.salvePolitica(this.empresa, this.numeroWhatsapp);
      this.windowRef.close();
      this.enviando = false;
    } catch (erro) {
      this.mensagemErro = erro;
      this.enviando = false;
    }
  }

  remova() {

  }

  fechar() {
    this.windowRef.close();
  }

  // Métodos de validação e formatação de telefone
  onTelefoneInput(event: any) {
    const value = event.target.value;
    const numeroLimpo = this.limparTelefone(value);

    // Aplica máscara dinâmica baseada no tamanho
    this.telefoneFormatado = this.aplicarMascaraDinamica(numeroLimpo);

    // Atualiza o valor no campo
    event.target.value = this.telefoneFormatado;

    // Remove formatação para salvar apenas números
    this.numeroWhatsapp.whatsapp = numeroLimpo;
  }

  onTelefoneBlur() {
    // Reaplica a formatação final
    if (this.telefoneFormatado) {
      const numeroLimpo = this.limparTelefone(this.telefoneFormatado);
      this.telefoneFormatado = this.aplicarMascaraDinamica(numeroLimpo);
      this.numeroWhatsapp.whatsapp = numeroLimpo;
    }
  }

  limparTelefone(telefone: string): string {
    if (!telefone) return '';
    // Remove todos os caracteres não numéricos
    return telefone.replace(/\D/g, '');
  }

  aplicarMascaraDinamica(numeroLimpo: string): string {
    if (!numeroLimpo) return '';

    // Limita a 11 dígitos
    if (numeroLimpo.length > 11) {
      numeroLimpo = numeroLimpo.substring(0, 11);
    }

    // Aplica formatação baseada no tamanho
    if (numeroLimpo.length <= 2) {
      return `(${numeroLimpo}`;
    } else if (numeroLimpo.length <= 6) {
      return `(${numeroLimpo.substring(0, 2)}) ${numeroLimpo.substring(2)}`;
    } else if (numeroLimpo.length <= 10) {
      // Formato fixo: (XX) XXXX-XXXX
      return `(${numeroLimpo.substring(0, 2)}) ${numeroLimpo.substring(2, 6)}-${numeroLimpo.substring(6)}`;
    } else {
      // Formato celular: (XX) XXXXX-XXXX
      return `(${numeroLimpo.substring(0, 2)}) ${numeroLimpo.substring(2, 7)}-${numeroLimpo.substring(7)}`;
    }
  }

  formatarTelefone(telefone: string): string {
    if (!telefone) return '';
    const numeroLimpo = telefone.replace(/\D/g, '');
    return this.aplicarMascaraDinamica(numeroLimpo);
  }

  validarTelefone(telefone: string): boolean {
    if (!telefone) return false;
    const telefoneLimpo = this.limparTelefone(telefone);

    // Validação para telefone brasileiro: aceita fixo (10 dígitos) e celular (11 dígitos)
    // Fixo: [1-9]{2}[2-5][0-9]{7} - DDD + número fixo (8 dígitos começando com 2-5)
    // Celular: [1-9]{2}9[6-9][0-9]{7} - DDD + 9 + número celular (8 dígitos começando com 6-9)
    const regexFixo = /^[1-9]{2}[2-5][0-9]{7}$/;
    const regexCelular = /^[1-9]{2}9[6-9][0-9]{7}$/;

    return regexFixo.test(telefoneLimpo) || regexCelular.test(telefoneLimpo);
  }

  get intervaloCalculadoSegundos(): number {
    const minimo = Math.max(10, Number(this.numeroWhatsapp.intervaloMinimoSegundos) || 60);
    const limitePorHora = Math.max(1, Number(this.numeroWhatsapp.limiteCampanhaPorHora) || 20);
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);
    const duracaoMinimaHoras = Math.max(1, Number(this.numeroWhatsapp.duracaoMinimaCampanhaHoras) || 4);
    const peloTetoHorario = Math.ceil(60 * 60 / limitePorHora);
    const pelaDuracaoMinima = Math.ceil(duracaoMinimaHoras * 60 * 60 / limiteDiario);

    return Math.max(minimo, peloTetoHorario, pelaDuracaoMinima);
  }

  get intervaloAutomacaoCalculadoSegundos(): number {
    const minimo = Math.max(10, Number(this.numeroWhatsapp.intervaloMinimoSegundos) || 60);
    const limitePorHora = Math.max(1, Number(this.numeroWhatsapp.limiteAutomacaoPorHora) || 8);
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);
    const pelaJanela = Math.ceil(this.duracaoDaJanelaHoras * 60 * 60 / limiteDiario);

    return Math.max(minimo, Math.ceil(60 * 60 / limitePorHora), pelaJanela);
  }

  get limiteMaximoSlider(): number {
    return 150;
  }

  get limiteElevado(): boolean {
    return !this.numeroWhatsapp.pausado && Number(this.numeroWhatsapp.limiteDiario) > 100;
  }

  get limiteDiarioAbaixoDoMinimo(): boolean {
    const limite = Number(this.numeroWhatsapp.limiteDiario);

    return !this.numeroWhatsapp.pausado &&
      Number.isFinite(limite) &&
      limite > 0 &&
      limite < 10;
  }

  get limiteSlider(): number {
    return this.numeroWhatsapp.pausado
      ? 0
      : Math.max(0, Math.min(this.limiteMaximoSlider, Number(this.numeroWhatsapp.limiteDiario) || 0));
  }

  get fundoDoSliderLimite(): string {
    const percentual = Math.min(100, Math.max(0,
      this.limiteSlider / this.limiteMaximoSlider * 100));
    const percentualRecomendado = 100 / this.limiteMaximoSlider * 100;

    if (this.limiteElevado) {
      return `linear-gradient(90deg, #178f5b 0%, #178f5b ${percentualRecomendado}%, ` +
        `#d97706 ${percentualRecomendado}%, #d97706 ${percentual}%, ` +
        `#dce5e1 ${percentual}%, #dce5e1 100%)`;
    }

    return `linear-gradient(90deg, #178f5b 0%, #178f5b ${percentual}%, ` +
      `#dce5e1 ${percentual}%, #dce5e1 100%)`;
  }

  atualizeLimitePeloSlider(evento: Event) {
    this.definaLimiteDiario(Number((evento.target as HTMLInputElement).value));
  }

  definaLimiteDiario(valor: number) {
    const valorInformado = Number(valor) || 0;

    if (valorInformado <= 0) {
      this.numeroWhatsapp.pausado = true;
      return;
    }

    const limite = Math.max(
      10,
      Math.min(this.limiteMaximoSlider, Math.round(valorInformado / 5) * 5)
    );

    this.numeroWhatsapp.limiteDiario = limite;
    this.numeroWhatsapp.pausado = false;
  }

  ajusteLimiteAJanela() {
    const limite = Number(this.numeroWhatsapp.limiteDiario);

    if (!Number.isFinite(limite)) {
      return;
    }

    this.numeroWhatsapp.limiteDiario = Math.max(
      10,
      Math.min(this.limiteMaximoSlider, Math.trunc(limite))
    );
  }

  get duracaoDaJanelaHoras(): number {
    const inicio = Number(this.numeroWhatsapp.janelaInicioHora);
    const fim = Number(this.numeroWhatsapp.janelaFimHora);

    if (!Number.isFinite(inicio) || !Number.isFinite(fim)) {
      return 0;
    }

    if (inicio === fim) {
      return 24;
    }

    return (fim - inicio + 24) % 24;
  }

  get limitePorHoraCalculado(): number {
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);

    return Math.max(1, Math.min(limiteDiario, Math.ceil(60 * 60 / this.intervaloCalculadoSegundos)));
  }

  get horaInicioFormatada(): string {
    const hora = Math.max(0, Math.min(23, Number(this.numeroWhatsapp.janelaInicioHora) || 0));

    return ('0' + hora).slice(-2);
  }

  get horaFimFormatada(): string {
    const hora = Math.max(0, Math.min(23, Number(this.numeroWhatsapp.janelaFimHora) || 0));

    return ('0' + hora).slice(-2);
  }

  get usadoHojeExibicao(): string {
    const usadoHoje = Number(this.numeroWhatsapp.usadoHoje);

    return Number.isFinite(usadoHoje) && usadoHoje >= 0 ? String(usadoHoje) : '—';
  }

  get restanteHojeCalculado(): number {
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);
    const restanteHoje = Number(this.numeroWhatsapp.restanteHoje);

    if (Number.isFinite(restanteHoje) && restanteHoje >= 0) {
      return Math.min(limiteDiario, restanteHoje);
    }

    const usadoHoje = Number(this.numeroWhatsapp.usadoHoje);
    if (Number.isFinite(usadoHoje) && usadoHoje >= 0) {
      return Math.max(0, limiteDiario - usadoHoje);
    }

    return limiteDiario;
  }

  get percentualUsadoHoje(): number {
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);
    const usadoHoje = Number(this.numeroWhatsapp.usadoHoje);

    if (!Number.isFinite(usadoHoje) || usadoHoje < 0) {
      return 0;
    }

    return Math.min(100, Math.round(usadoHoje / limiteDiario * 100));
  }

  formateDuracao(segundos: number): string {
    const total = Math.max(0, Math.ceil(Number(segundos) || 0));
    const horas = Math.floor(total / 3600);
    const minutos = Math.floor((total % 3600) / 60);
    const segundosRestantes = total % 60;
    const partes: string[] = [];

    if (horas) {
      partes.push(horas + 'h');
    }
    if (minutos) {
      partes.push(minutos + 'min');
    }
    if (segundosRestantes && !horas) {
      partes.push(segundosRestantes + 's');
    }

    return partes.length ? partes.join(' ') : 'agora';
  }
}
